import * as Yup from 'yup';

export const reviewFormSchema = Yup.object().shape({
  clientName: Yup.string().required('Enter client name'),
  projectName: Yup.string().required('Enter project name'),
  platformValue: Yup.array().min(1, 'Select a platform').required('Choose a platform'),
});
